(function () {
  'use strict';

  angular.module('app').component('vehicleDetail', vehicleDetail());

  function vehicleDetail() {
    return {
      bindings: {
        item: '=',
        hideTopControls: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
        defaultLanguage: '<',
        additionalLanguages: '<',
      },
      controller: VehicleDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/vehicles/vehicle-detail/vehicle-detail.component.html',
    };
  }

  VehicleDetailComponent.$inject = [
    'UtilService',
    'VehicleService',

    // Angular downgraded service
    'occupancyTypeService',
    'occupancyTypeModalService',
  ];

  function VehicleDetailComponent(
    UtilService,
    VehicleService,

    // Angular downgraded service
    occupancyTypeService,
    occupancyTypeModalService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    // private properties
    // -----------------------
    let cropedImage = { file: null };

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        vm.flashMessage = vm.UtilService._displayFlashMessage();
        setItemOptions(vm.item);
      } else {
        // New
        vm.createMode = true;

        vm.labelAddLogo = 'ADD_PHOTO';
      }

      getOccupancyTypes();
    };

    // public methods
    // -----------------------

    vm.openOccupancyTypesModal = function () {
      // const successCallback = () => {
      //   getOccupancyTypes();
      // };

      occupancyTypeModalService.openOccupancyTypesModal(getOccupancyTypes);
    };

    vm.openTranslations = function () {
      VehicleService.openVehicleTranslations(vm.item, vm.additionalLanguages);
    };

    vm.openLogo = function () {
      let logoSaved = (cropedImageObj) => {
        cropedImage = cropedImageObj;

        if (vm.editMode) {
          VehicleService.updateLogo(vm.item, cropedImage);
        } else {
          var img = document.getElementById('logo-image-preview'); // <HTMLInputElement>
          img.src = URL.createObjectURL(cropedImage.file);
        }
      };

      VehicleService.openLogo(vm.item, logoSaved);
    };

    // Create/Update
    vm.saveVehicle = function (isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;
        vm.UtilService.scrollToTop();

        return;
      }

      vm.sendingForm = true;
      VehicleService.saveVehicle(vm.item, vm.defaultLanguage, cropedImage).then(
        function (response) {
          let data = response.data;

          if (!vm.editMode) {
            // create
            vm.onSavedItem({ item: data });
          } else {
            vm.flashMessage = vm.UtilService._clearFlashMessage();

            //vm.itemName = data.name;

            setItemOptions(data);

            vm.UtilService.scrollToTop();
          }

          vm.sendingForm = false;
        },
        function (response) {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.data.errors);

          vm.formErrors = true;
          vm.UtilService.scrollToTop();

          vm.sendingForm = false;
        }
      );
    };

    vm.cancel = function () {
      vm.onCanceledItem({ item: vm.item });
    };

    // private methods
    // -----------------------
    function setItemOptions(item) {
      vm.editMode = true;

      vm.itemName = item.name;

      vm.labelAddLogo = vm.item.logo.url ? 'CHANGE_PHOTO' : 'ADD_PHOTO';
    }

    function getOccupancyTypes() {
      let params = {
        get: 'active',
        skip_check_role: true,
        lang: vm.defaultLanguage,
      };

      vm.loadingOcupancyTypes = true;
      occupancyTypeService.getOccupancyTypes(params).subscribe((response) => {
        vm.occupancyTypes = response;
      });
    }
  }
})();
